// extracted by mini-css-extract-plugin
module.exports = {"layout":"sticky-sidebar_layout__W_AyY"};